import { ActivityIndicator, View } from "react-native";
import React, { useEffect, useMemo, useState } from "react";
import { Text } from "@ui-kitten/components";
import ScheduleItemList from "screens/Schedule/ScheduleItemList";
import { useAccount } from "hooks/useAccount";
import { useFetchEventAvailablitiesQuery } from "queries/ticket.queries";
import Button from "components/Button";
import { MainFlowParamList } from "navigation/types";
import { useNavigation, NavigationProp } from "@react-navigation/native";
import { useAppSelector } from "hooks/useAppSelector";
import { useAppDispatch } from "hooks/useAppDispatch";
import { setSelectedSubscription } from "features/slices/reservationFlowSlice";
import i18n from "plugins/localization";
import TDCDialog from "screens/Schedule/components/TDCDialog";
import { getUniqSubscriptions } from "utils/subscriptionUtils";

const UpcomingGames = () => {
  const [TDCDialogVisible, setTDCDialogVisible] = useState(false);
  const { account } = useAccount();
  const dispatch = useAppDispatch();
  const { selectedSubscription } = useAppSelector(
    (state) => state.reservationFlow
  );

  const {
    data: schedule,
    refetch,
    isFetching,
  } = useFetchEventAvailablitiesQuery({
    accountId: account!.id,
    planPackageId: selectedSubscription?.planPackage.id,
  });

  const navigation = useNavigation<NavigationProp<MainFlowParamList>>();

  const uniqSubscriptions = useMemo(() => {
    if (!account) return [];
    return getUniqSubscriptions(account.subscriptions);
  }, [account]);

  const firstFiveHomeGames = useMemo(() => {
    return schedule ? schedule.slice(0, 5) : [];
  }, [schedule]);

  const planPackageOperable = selectedSubscription?.operative || false;

  // On page loads, set selected subscription to the first one available
  // return if already set
  useEffect(() => {
    if (uniqSubscriptions.length === 0 || selectedSubscription !== null) return;
    dispatch(setSelectedSubscription(uniqSubscriptions[0]));
  }, [uniqSubscriptions]);

  // On selected subscription change, fetch evetn availablities
  useEffect(() => {
    if (!selectedSubscription) return;
    refetch();
  }, [selectedSubscription]);

  if (!schedule) return null;

  return (
    <View>
      <TDCDialog
        visible={TDCDialogVisible}
        setVisible={setTDCDialogVisible}
        cancelText="CLOSE"
      />
      {schedule.length > 0 && (
        <View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 15,
            }}
          >
            <Text category="h6">
              {`${i18n.t("screens.Dashboard.nextHomeGames")}`}:
            </Text>
            {isFetching && <ActivityIndicator />}
            <Button
              onPress={() =>
                navigation.navigate("Schedule", {
                  screen: "ScheduleScreen",
                })
              }
              appearance="ghost"
            >
              {`${i18n.t("screens.Dashboard.viewMore")} >`}
            </Button>
          </View>
          <ScheduleItemList
            schedule={firstFiveHomeGames}
            selectedSubscription={selectedSubscription}
            planPackageOperable={planPackageOperable}
            setTDCDialog={setTDCDialogVisible}
          />
        </View>
      )}
    </View>
  );
};

export default UpcomingGames;
